export default __webpack_public_path__ + "static/media/qkn-ca.ff393317.svg";